import useTranslation from 'next-translate/useTranslation';

import Image from '~/domains/common/components/Image/Image';
import { LinkNew } from '~/domains/common/components/Link/Link';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import testIds from '~/domains/home/testing.const';
import { IconChevronRight } from '~/domains/design-system/icons/IconChevronRight';

import { useStyles } from './CarouselHeader.styles';

const ICON_SIZE = 24;

type CarouselHeaderProps = {
  iconUrl?: string;
  title: string;
  viewMoreHref: string;
  labelParts: string[];
};

export function CarouselHeader({ iconUrl, title, viewMoreHref, labelParts }: CarouselHeaderProps) {
  const { t } = useTranslation('home');
  const { classes, theme } = useStyles();

  const viewAllLabel =
    labelParts.length > 0
      ? t('condensedCarousels.viewAll', { label: labelParts.join(' ') })
      : t('condensedCarousels.viewAllContests');

  return (
    <div className={classes.header}>
      <div className={classes.heading}>
        {iconUrl && (
          <Image
            className={classes.icon}
            src={iconUrl}
            alt=""
            width={ICON_SIZE}
            height={ICON_SIZE}
            fallbackComponent={null}
          />
        )}
        <Title variant="subhead-large" tag="h3" color="black">
          {title}
        </Title>
      </div>
      <LinkNew href={viewMoreHref} data-test-id={testIds.components.condensedCarousels.viewAll}>
        <span className={classes.viewAll}>
          <Text variant="body-large" color="gray2.3">
            {viewAllLabel}
          </Text>
          <IconChevronRight size={16} color={theme.colors.gray2[3]} />
        </span>
      </LinkNew>
    </div>
  );
}
